module.exports = __webpack_public_path__ + "img/tag3.f3ca93a3.png";